import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next'; // Importer useTranslation

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect({ label, wrapperClasses, options, value, onChange,
  emptyLabel, size, disabled,
  format = { value: 'value', label: 'label' }, defaultFormat, marginRight }) {

  const { t } = useTranslation('add_task_enterprise');

  if (defaultFormat) format = { value: 'id', label: 'name' };

  const theme = useTheme();

  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <div>
      <FormControl fullWidth sx={{}}>
        <InputLabel id="demo-multiple-chip-label">
          {value?.length < 1 ? label : t('selected_count', { count: value?.length })} {/* Traduit */}
        </InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={value || []} // Utiliser la prop `value` et s'assurer que c'est un tableau
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={value?.length < 1 ? label : t('selected_count', { count: value?.length })} />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((selectedValue) => (
                <Chip
                  key={selectedValue}
                  label={options?.find((op) => op[format?.value] === selectedValue)?.[format?.label] || emptyLabel}
                />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
          disabled={disabled} // Ajouter la prop disabled
        >
          {options && options
            ?.sort((a, b) => (a[format?.label] > b[format?.label] ? 1 : -1))
            ?.map((option) => (
              <MenuItem
                key={option[format?.value]}
                value={option[format?.value]}
                style={getStyles(option[format?.label], value || [], theme)} // Utiliser la prop `value`
              >
                {option[format?.label]}
              </MenuItem>
            ))}
            {/* Ajouter une option vide si `emptyLabel` est fourni */}
            {emptyLabel && (
                <MenuItem value="" disabled>
                    <em>{emptyLabel}</em>
                </MenuItem>
            )}
        </Select>
      </FormControl>
    </div>
  );
}